<template>
    <div class="row">
        <div class="col-8">
            <h3>Nested draggable</h3>
            <div v-show="showAddForm">
                Keine Kategorien vorhanden.
                <br>
                <button @click="addChildCategory()" class="btn btn-primary btn-sm">
                    Erste Kategorie anlegen
                </button>

            </div>
            <NestedDraggable v-if="categories.length > 0"
                              :parentid="null"
                              :categories="categories"
                              :selectedItems="selectedItems"
                              @toggle-children="handleSelection"
                              @deleteCategory="deleteCategory"
                              @addChildCategory="addChildCategory"
                              @saveChildCategory="saveChildCategory"
                              @updateCategory="updateCategory"
                              @updateSorting="updateSorting"/>
        </div>
    </div>
</template>

<script>
import NestedDraggable from "./NestedDraggable";


export default {
    name: "CategoryTreeDraggable",
    display: "Nested",
    order: 15,
    components: {
        NestedDraggable,



    },
    data() {
        return {
            categories: [],
            selectedItems: [],
            showAddForm: false
        };
    },
    mounted () {
        this.getCategoriesFromDB();

    },
    updated() {
        this.checkIfCategoriesAreEmpty();
    },

    methods: {

        checkIfCategoriesAreEmpty(){
            if(this.categories.length === 0) {
                return this.showAddForm = true;
            }
            else {
                return this.showAddForm = false;
            }
        },

        getCategorySiblings(pCategory) {
            return this.categories.filter(category => category.parent_id === pCategory.parent_id)
                .sort((a, b) => a.sort_order - b.sort_order);
        },

        getChildrenFromParentCategory(parentCategory) {
            return this.categories.filter(category => category.parent_id === parentCategory.id)
                .sort((a, b) => a.sort_order - b.sort_order);
        },

        updateSortingInDB(updatedCategory) {
            axios
                .put('/categories/' + updatedCategory.id + '/edit', {
                    name: updatedCategory.name,
                    sort_order:  updatedCategory.sort_order
                })
        },

        updateCategory(updatedCategory) {
            let index = this.categories.findIndex((category) => category.id === updatedCategory.id);
            this.categories[index] = updatedCategory;
        },

        saveChildCategory(category) {
            this.categories.pop(); //remove the dummy
            this.categories.unshift(category);
        },

        deleteCategory(deletedCategory) {
            this.categories = this.categories.filter(category => category.id !== deletedCategory.id);
        },

        handleSelection(category) {
            if(this.selectedItems.includes(category, 0)){
                this.selectedItems = this.selectedItems.filter(item => item.id !== category.id);
            } else {
                this.selectedItems.push(category)
            }
            if(category.parent_id != null) {
                let parentcategory = this.getParentCategory(category)
                this.selectedItems.push(parentcategory)
            }
        },

        getParentCategory(category) {
            for (let categoryelement of this.categories) {
                if(categoryelement.id === category.parent_id) {
                    return categoryelement;
                }
            }
        },

        addChildCategory(category) {
            if(category != null) {
                let list = this.getChildrenFromParentCategory(category)
                this.categories.push({
                    name: "Neue Kategorie",
                    sort_order: list.length,
                    parent_id: category.id,
                })
            } else {
                this.categories.push({
                    name: "Neue Kategorie",
                    sort_order: 0,
                    parent_id: null,
                })
            }

        },

        updateSorting(updatedCategory, moveUp) {
            let categorySiblings = this.getCategorySiblings(updatedCategory)

            for (var i = 0; i < categorySiblings.length; i++) {
                if(updatedCategory.id === categorySiblings[i].id ) {
                    categorySiblings[i] = updatedCategory;
                } else if(updatedCategory.sort_order === categorySiblings[i].sort_order && moveUp) {
                    categorySiblings[i].sort_order = categorySiblings[i].sort_order + 1
                } else if(updatedCategory.sort_order === categorySiblings[i].sort_order && !moveUp) {
                    categorySiblings[i].sort_order = categorySiblings[i].sort_order - 1
                } else {
                    categorySiblings[i].sort_order = i;
                }
                this.updateCategory(categorySiblings[i])
                this.updateSortingInDB(categorySiblings[i])
                //when dragging the category into another level: the parent toggle should be open:
                this.handleSelection(updatedCategory)
            }
        },

        getCategoriesFromDB() {
            axios
                .get('/admin/categories')
                .then(response => (
                    this.categories = response.data
                ))
                .catch(error => {
                    console.log(error)
                })

        },

    }

};
</script>
<style scoped></style>
